var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"injury-badge",class:{ 'injury-badge--dense': _vm.dense },style:(_vm.badgeStyle)},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }